import {
  GET_DOCUMENTS_LIST,
  GET_DOCUMENTS_LIST_SUCCESS,
  GET_DOCUMENTS_LIST_FAILED,
  ADD_DOCUMENT,
  ADD_DOCUMENTS_SUCCESS,
  ADD_DOCUMENT_FAILED,
  EDIT_DOCUMENT,
  EDIT_DOCUMENTS_SUCCESS,
  EDIT_DOCUMENT_FAILED,
  CHANGE_THE_DOC_STATUS,
  CHANGE_THE_DOC_STATUS_SUCCESS,
  CHANGE_THE_DOC_STATUS_FAILED,
  ADD_THE_VERIFICATION_DOCS,
  ADD_THE_VERIFICATION_DOCS_SUCCESS,
  ADD_THE_VERIFICATION_DOCS_FAILED,
  GET_VERIFICATION_DOC_DETAILS,
  GET_VERIFICATION_DOC_DETAILS_SUCCESS,
  GET_VERIFICATION_DOC_DETAILS_FAILED,
  SUBMIT_DOC_STATUS,
  SUBMIT_DOC_STATUS_SUCCESS,
  SUBMIT_DOC_STATUS_FAILED,
} from "./actionTypes"

export const getDocumentsList = (data) => {
  return {
    type: GET_DOCUMENTS_LIST,
    payload: data,
  };
};
export const getDocumentsListSuccess = (data) => {
  return {
    type: GET_DOCUMENTS_LIST_SUCCESS,
    payload: data,
  };
};
export const getDocumentsListFailed = (error) => {
  return {
    type: GET_DOCUMENTS_LIST_FAILED,
    payload: error,
  };
};

export const addDocument = (data) => {
  return {
    type: ADD_DOCUMENT,
    payload: data,
  };
};

export const addDocumentSuccess = (data) => {
  return {
    type: ADD_DOCUMENTS_SUCCESS,
    payload: data,
  };
};

export const addDocumentFailed = (error) => {
  return {
    type: ADD_DOCUMENT_FAILED,
    payload: error,
  };
};

export const editDocument = (data) => {
  return {
    type: EDIT_DOCUMENT,
    payload: data,
  };
};
export const editDocumentSuccess = (data) => {
  return {
    type: EDIT_DOCUMENTS_SUCCESS,
    payload: data,
  };
};
export const editDocumentFailed = (error) => {
  return {
    type: EDIT_DOCUMENT_FAILED,
    payload: error,
  };
};

export const changeTheDocStatus = (data) => {
  return {
    type: CHANGE_THE_DOC_STATUS,
    payload: data,
  };
};

export const changeTheDocStatusSuccess = (data) => {
  return {
    type: CHANGE_THE_DOC_STATUS_SUCCESS,
    payload: data,
  };
};

export const changeTheDocStatusFailed = (error) => {
  return {
    type: CHANGE_THE_DOC_STATUS_FAILED,
    payload: error,
  };
};

export const addTheVerificationDocs=(data)=>{
  return{
    type:ADD_THE_VERIFICATION_DOCS,
    payload:data
  }
}

export const addTheVerificationDocsSuccess=(data)=>{
  return{
    type:ADD_THE_VERIFICATION_DOCS_SUCCESS,
    payload:data
  }
}

export const addTheVerificationDocsFailed=(error)=>{
  return{
    type:ADD_THE_VERIFICATION_DOCS_FAILED,
    payload:error
  }
}

export const getVerificationDocDetails=(data)=>{
  return{
    type:GET_VERIFICATION_DOC_DETAILS,
    payload:data
  }
}

export const getVerificationDocDetailsSuccess=(data)=>{
  return{
    type:GET_VERIFICATION_DOC_DETAILS_SUCCESS,
    payload:data
  }
}

export const getVerificationDocDetailsFailed=(error)=>{
  return{
    type:GET_VERIFICATION_DOC_DETAILS_FAILED,
    payload:error
  }
}

export const submitDocStatus=(data)=>{
  return {
    type:SUBMIT_DOC_STATUS,
    payload:data
  }

}

export const submitDocStatusSuccess=(data)=>{
  return {
    type:SUBMIT_DOC_STATUS_SUCCESS,
    payload:data
  }

}

export const submitDocStatusFailed=(error)=>{
  return {
    type:SUBMIT_DOC_STATUS_FAILED,
    payload:error
  }

}


